import { AuditLogEntry } from "./types";

export const mockAuditLogs: AuditLogEntry[] = [
  {
    id: "1",
    timestamp: "2023-10-27T10:30:00Z",
    user: "admin@example.com",
    action: "Change permission",
    environment: "Prod",
    details: {
      previousState: { role: "viewer" },
      newState: { role: "editor" },
    },
  },
  {
    id: "2",
    timestamp: "2023-10-27T11:15:00Z",
    user: "jdoe@example.com",
    action: "Deleted Workshop",
    environment: "Dev",
    details: {
      previousState: { workshopId: "123", name: "Intro to React" },
      newState: null,
    },
  },
  {
    id: "3",
    timestamp: "2023-10-26T09:00:00Z",
    user: "admin@example.com",
    action: "Update Settings",
    environment: "QA",
    details: {
      previousState: { theme: "light", notifications: true },
      newState: { theme: "dark", notifications: true },
    },
  },
  {
    id: "4",
    timestamp: "2023-10-25T14:20:00Z",
    user: "mmanager@example.com",
    action: "Create User",
    environment: "Prod",
    details: {
      previousState: null,
      newState: { userId: "456", email: "newuser@example.com" },
    },
  },
  {
    id: "5",
    timestamp: "2023-10-28T08:45:00Z",
    user: "tester@example.com",
    action: "Run Test Suite",
    environment: "Dev",
    details: {
      previousState: { status: "pending" },
      newState: { status: "passed" },
    },
  },
];
